import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-tous-bon-sortie',
  templateUrl: './tous-bon-sortie.component.html',
  styleUrls: ['./tous-bon-sortie.component.scss']
})
export class TousBonSortieComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
